import { create } from 'zustand';

import { RoleWithPrompts } from '@services/types';

type RoleWithPromptsRenamedProperty = Omit<RoleWithPrompts, 'role'> & { value: string };

type RoleState = {
    role: RoleWithPromptsRenamedProperty | null;
    setRole: (role: RoleWithPromptsRenamedProperty | null) => void;
};

export const useRoleStore = create<RoleState>((set) => ({
    role: null,
    setRole: (role) => set({ role }),
}));
